import { useState, useEffect } from 'react';

import ScreenWidth from 'const/screen-size-constant';

interface IScreenSize {
  isMobile: boolean;
  isTablet: boolean;
}

const useScreenSize = (): IScreenSize => {
  const [screenSize, setScreenSize] = useState<{ height: number; width: number }>({
    height: window.innerHeight,
    width: window.innerWidth
  });

  const handleResize = (): void => {
    setScreenSize({
      height: window.innerHeight,
      width: window.innerWidth
    });
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    isMobile: screenSize.width <= ScreenWidth.MOBILE,
    isTablet: screenSize.width <= ScreenWidth.SCREEN_MD
  };
};

export default useScreenSize;
